module.exports = __webpack_public_path__ + "img/layer-backward.42df3fed.svg";